<template>
  <base-container :isLoading="loading">
    <div class="artisan-top-container">
      <h2 class="artisan-center">水费查询</h2>
      <WaterFee @water-confirm="waterConfirm"></WaterFee>
      <van-button class="artisan-btn" type="info" round block @click="query">查询</van-button>
      <div>
        <van-cell-group title="水费">
          <van-cell title="户号" :value="info.consNo" />
          <van-cell title="户名" :value="info.consName" />
          <van-cell title="住址信息" :value="info.addr" />
          <van-cell title="单位编码" :value="info.orgNo" />
          <van-cell title="单位名称" :value="info.orgName" />
          <van-cell title="账户余额" :value="info.balance" />
          <van-cell title="分组名称" :value="info.groupName" />
        </van-cell-group>
      </div>
    </div>
  </base-container>
</template>

<script>
import { queryUserInfo } from "@/api/waterfee";
import WaterFee from "./Waterfee";
export default {
  components: {
    WaterFee,
  },
  data() {
    return {
      loading: false,
      info: {},
      waterNo: "",
      groupName: "",
    };
  },
  created() {},
  methods: {
    waterConfirm(obj) {
      this.waterNo = obj.waterNo;
      this.groupName = obj.groupName;
    },
    query() {
      this.loading = true;
      queryUserInfo(this.waterNo, this.groupName)
        .then((res) => {
          this.loading = false;
          this.info = res.data.value.consInfo[0];
          this.info.groupName = this.groupName;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.wtf-title {
  font-weight: bold;
  color: #323233;
  font-size: 0.9rem;
}
.wtf-dec {
  font-size: 0.7rem;
}
.wtf-time {
  font-size: 0.6rem;
  color: gray;
}
</style>